"use strict";

if (process.env.NODE_ENV === "production") {
  module.exports = require("./cjs/react-router-dom.min.js");
} else {
  module.exports = require("./cjs/react-router-dom.js");
}



//////////////////
// WEBPACK FOOTER
// /data/www/SGDBackend-Nex2/~/react-router-dom/index.js
// module id = 11
// module chunks = 0